import React from "react";
import { PublicNavbar } from "../ui/public-navbar";
import { cn } from "../../lib/utils";
import Footer from "../../footer/footer";

export function PublicLayout({ children, className, ...props }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <PublicNavbar />
      <main className={cn("flex-1", className)} {...props}>
        {children}
      </main>
      <Footer />
    </div>
  );
}
